/**
 * 公共配置文件
 */



const isDev = process.env.NODE_ENV === 'development'
const isTest = process.env.NODE_ENV === 'development'

const configObj = {
	isDevelop: (isDev || isTest),
	baseURL: 'http://editor.xingxiaochu.com',
	//baseURL: 'http://192.168.1.7:4000',
	// h5模式宽高
	canvasH5Width: 375,
	canvasH5Height: 644,
	pageModeList: [
		{
			value: 'longPage',
			label: '长页',
			disabled: false
		},{
		value: 'h5',
		label: '多页',
		disabled: false
	}/*, {
		name: 'relativePage',
		label: '排版图文',
		disabled: true
	}, {
		value: 'pc',
		label: 'PC页面',
		disabled: true
	}*/]
}

export default configObj
